module.exports = "/_next/static/images/ourPartnersDishLogo-a0b464316a77015f5921e5cc1360f2f4.webp";